<div class="grid grid-cols-1 lg:grid-cols-3 m-3 gap-3" lohiPageTitle="Billing Export">
  <div>
    <div class="card-with-shadow bg-white">
      <div class="p-2 border-b border-gray-400">
        <div class="font-bold text-gray-700 text-lg">Bulk Export</div>
        <ng-container *ngIf="exporting$$ | async; else showBulkExportForm">
          <div class="flex justify-center">
            <mat-spinner diameter="57"></mat-spinner>
          </div>
        </ng-container>
        <ng-template #showBulkExportForm>
          <mat-form-field class="w-full" *ngIf="bulkExportFormGroup">
            <mat-label>Loads Ordered Between</mat-label>
            <mat-date-range-input [formGroup]="bulkExportFormGroup" [rangePicker]="picker">
              <input matStartDate formControlName="start" placeholder="Start date" />
              <input matEndDate formControlName="end" placeholder="End date" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </ng-template>
      </div>
      <div class="p-2 flex justify-end">
        <span
          (click)="exportBulkData()"
          class="text-blue-500 cursor-pointer font-bold"
          [class.opacity-50]="exporting$$ | async"
          >Export</span
        >
      </div>
    </div>

    <div class="card-with-shadow bg-white mt-2">
      <div class="p-2 border-b border-gray-400">
        <div class="font-bold text-gray-700 text-lg">Tax Export</div>
        <ng-container *ngIf="exporting$$ | async; else showTaxExportForm">
          <div class="flex justify-center">
            <mat-spinner diameter="57"></mat-spinner>
          </div>
        </ng-container>
        <ng-template #showTaxExportForm>
          <mat-form-field class="w-full" *ngIf="taxExportFormGroup">
            <mat-label>Export Dates</mat-label>
            <mat-date-range-input [formGroup]="taxExportFormGroup" [rangePicker]="picker">
              <input matStartDate formControlName="start" placeholder="Start date" />
              <input matEndDate formControlName="end" placeholder="End date" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </ng-template>
      </div>
      <div class="p-2 flex justify-end">
        <span
          (click)="exportTaxData()"
          class="text-blue-500 cursor-pointer font-bold"
          [class.opacity-50]="exporting$$ | async"
          >Export</span
        >
      </div>
    </div>
  </div>

  <div>
    <div class="card-with-shadow bg-white">
      <div class="p-2 border-b border-gray-400">
        <div class="font-bold text-lg text-gray-700">Billing Performance</div>
        <div class="pt-2 pb-2 flex border-b border-gray-400" *lohiFeatureFlag="'billingPerformanceDSO'">
          <div class="flex-1 text-gray-700">DSO</div>
          <div class="text-gray-800">1.2 days</div>
        </div>
        <div class="pt-2 pb-2 flex border-b border-gray-400 cursor-pointer" (click)="navigateToLoadsList('missingPOD')">
          <div class="flex-1 text-gray-700">Loads Missing POD</div>
          <lohi-number-badge
            [showIfZero]="true"
            [bgClass]="(loadsMissingPODCount$ | async) === 0 ? 'bg-blue-500' : 'bg-red-500'"
            [count]="loadsMissingPODCount$ | async"
          ></lohi-number-badge>
        </div>
        <div
          class="pt-2 pb-2 flex border-b border-gray-400 cursor-pointer"
          (click)="navigateToLoadsList('missingPOD24Hrs')"
        >
          <div class="flex-1 text-gray-700">Loads Missing POD >24hrs</div>
          <lohi-number-badge
            [showIfZero]="true"
            [bgClass]="(loadsMissingPODCount$ | async) === 0 ? 'bg-blue-500' : 'bg-red-500'"
            [count]="loadsMissingPODCountMoreThan24Hours$ | async"
          ></lohi-number-badge>
        </div>
        <div class="pt-2 pb-2 flex">
          <div class="flex-1 text-gray-700">Average Working Days to Approve</div>
          <lohi-number-badge
            [showIfZero]="true"
            [bgClass]="'bg-blue-500'"
            [count]="loadsAverageDaysToApprove$ | async"
          ></lohi-number-badge>
        </div>
      </div>
      <div class="p-2 flex justify-end">
        <a
          *lohiFeatureFlag="'openInSandiBilling'"
          class="text-blue-500 font-bold mr-3 cursor-pointer"
          (click)="goToSandiBilling()"
          >Go To SANDi Billing &#8594;</a
        >
        <a class="text-blue-500 font-bold" routerLink="/loads/list/completed">Go To Billing &#8594;</a>
      </div>
    </div>
  </div>
</div>
